'use client';

import { colors } from '../Colors/index.js';

var DEFAULT_DRAG_DROP_FILE_STYLE = {
    borderColor: colors.primary[30],
    backgroundColor: colors.primary[100]
};
var DEFAULT_SECONDARY_DRAG_DROP_FILE_STYLE = {
    borderColor: colors.grey[60],
    backgroundColor: colors.grey[99]
};

export { DEFAULT_DRAG_DROP_FILE_STYLE, DEFAULT_SECONDARY_DRAG_DROP_FILE_STYLE };
//# sourceMappingURL=constants.js.map
